import { render, staticRenderFns } from "./psychologistCards.vue?vue&type=template&id=3af888ab&scoped=true"
import script from "./psychologistCards.vue?vue&type=script&lang=js"
export * from "./psychologistCards.vue?vue&type=script&lang=js"
import style0 from "./psychologistCards.vue?vue&type=style&index=0&id=3af888ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af888ab",
  null
  
)

export default component.exports